import { ReportState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    reportValidation: (state: ReportState) => state.report_validation,
    product: (state: ReportState) => state.product,
    productMaterials: (state: ReportState) => state.product?.materials,
    finance: (state: ReportState) => state.finance,
    financeMaterials: (state: ReportState) => state.finance?.materials,
    financialInfoMaterials: (state: ReportState) => state.financialInfoMaterials,
    fundraising: (state: ReportState) => state.fundraising,
    reports: (state: ReportState) => state.reports,
    reportData: (state: ReportState) => state.reportData,
    reportId: (state: ReportState) => state.report_id,
};

const {read} = getStoreAccessors<ReportState, State>('');
export const readReportValidation = read(getters.reportValidation);
export const readProduct = read(getters.product);
export const readProductMaterials = read(getters.productMaterials);
export const readFinance = read(getters.finance);
export const readFinanceMaterials = read(getters.financeMaterials);
export const readFinancialInfoMaterials = read(getters.financialInfoMaterials);
export const readFundraising = read(getters.fundraising);
export const readReports = read(getters.reports);
export const readReportData = read(getters.reportData);
export const readReportId = read(getters.reportId);